import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { FilterType } from '@keepeek/commons';
import BusinessFilterAdvanced from './BusinessFilterAdvanced.js';
import BusinessFilterFacet from './BusinessFilterFacet.js';

/**
 * Show a business filter
 * @author JBO
 */
var BusinessFilter = function (_a) {
    var data = _a.data, configFilters = _a.configFilters, dataViewKey = _a.dataViewKey, rest = __rest(_a, ["data", "configFilters", "dataViewKey"]);
    switch (data.type) {
        case FilterType.FacetMulti:
        case FilterType.Facet:
            return (React__default.createElement(BusinessFilterFacet, __assign({ filter: data, configFilters: configFilters, dataViewKey: dataViewKey }, rest)));
        case FilterType.Advanced:
            return React__default.createElement(BusinessFilterAdvanced, __assign({ filter: data, dataViewKey: dataViewKey }, rest));
        default:
            console.debug("BusinessFilter of type ".concat(data.type, " is not yet implemented"));
            return null;
    }
};

export { BusinessFilter as default };
//# sourceMappingURL=BusinessFilter.js.map
